<ng-form #stepForm="ngForm">
    <h3 class="p-t-4">
        <span class="p2 left">{{'Choose payment method' | translate}}</span>
    </h3>

    <!-- shipping methods -->
    <ng-container [ngSwitch]="noPaymentNeeded">
        <!-- virtual order -->
        <p class="label"
           *ngSwitchCase="true">{{'No payment information required.' | translate}}</p>

        <!-- regular order -->
        <div *ngSwitchCase="false">
            <!-- no methods found notice -->
            <p class="label"
               translate
               *ngIf="!methods.length">{{'No payment methods found.' | translate}}</p>

            <!-- methods list -->
            <radio-group name="method"
                         [(ngModel)]="data.method"
                         (ngModelChange)="detectChanges()">
                <ng-container
                              *ngFor="let method of methods | applePayFilter : [MOLLIE_APPLE_PAY]; let isLast = last trackBy methodTrackFn">
                    <div class="bg-col-51 p-a m-t-3 flex flex-justify-between flex-middle"
                         [ngSwitch]="method.code">
                        <radio class="w-12 p-l-9 p-l-8-m"
                               [value]="method.code"
                               [disabled]="disabled">
                            <span class="s1">{{getMethodTitle(method)}}</span>
                        </radio>

                        <div *ngSwitchCase="'klarna_pay_over_time'">
                            <span class="payment-method-logo payment-method-logo--klarna"></span>
                        </div>

                        <div *ngSwitchCase="'paypal_express'">
                            <span class="payment-method-logo payment-method-logo--paypal"></span>
                        </div>

                        <div *ngSwitchCase="'braintree_paypal'">
                            <span class="payment-method-logo payment-method-logo--paypal"></span>
                        </div>

                        <div *ngSwitchCase="'stripe_payments'"
                             class="flex">
                            <span class="payment-method-logo payment-method-logo--visa m-r-1"></span>
                            <span class="payment-method-logo payment-method-logo--mastercard m-r-1"></span>
                            <span class="payment-method-logo payment-method-logo--amex m-r-1"></span>
                        </div>

                        <div *ngSwitchCase="'stripe_payments_express'">
                            @for (logo of getStripeExpressCheckoutLogos(); track logo) {
                            <span class="payment-method-logo payment-method-logo--{{logo}}"></span>
                            }
                        </div>

                        <div *ngSwitchCase="MOLLIE_APPLE_PAY">
                            <span class="payment-method-logo payment-method-logo--apple"></span>
                        </div>
                    </div>

                    <braintree-hosted-fields *ngIf="method.code === 'braintree'"
                                             class="block p-l p-r w-12 left bg-col-51"
                                             [ngClass]="{'visually-hidden' : data.method !== method.code}">
                    </braintree-hosted-fields>

                    <mollie-cards-payment *ngIf="method.code === 'mollie_methods_creditcard' && data.method === method.code"
                                          class="block p-l p-r w-12 left bg-col-51"
                                          [ngClass]="{'visually-hidden' : data.method !== method.code}">
                    </mollie-cards-payment>

                    <stripe-saved-card *ngIf="method['isCard']"
                                       [card]="$any(method)"
                                       [ngClass]="{'visually-hidden' : data.method !== method.code}">
                    </stripe-saved-card>

                    <stripe-card *ngIf="method.code === 'stripe_payments'"
                                 class="block p-l p-r w-12 left bg-col-51"
                                 [ngClass]="{'visually-hidden' : data.method !== method.code}"></stripe-card>

                    <ng-container *ifKlarnaPayment="method.code + ''">
                        <klarna-payment [methodCode]="$any(method.code)"
                                        [ngClass]="{'visually-hidden': data.method !== method.code}"
                                        class="block b-b b-col-4"></klarna-payment>
                    </ng-container>

                </ng-container>
            </radio-group>

            <input-wrap>
                <input type="hidden"
                       [(ngModel)]="data.method"
                       name="paymentMethod"
                       required>
            </input-wrap>

        </div>
    </ng-container>
</ng-form>